import type { PreClaimsTypesResponse } from './api';

export const normalizePreClaimsTypes = (
  list: PreClaimsTypesResponse,
): {
  label: string;
  value: number;
}[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.claimTypeDesc,
    value: row.claimTypeKey,
  }));
};
